import { createAction } from "@ngrx/store";
import { FeatureFlagModel } from "../models/featureFlag.model";

export const ADD_FEATURE_FLAGS = createAction(
  "ADD_FEATURE_FLAGS",
  (flags: FeatureFlagModel[]) => ({
    flags,
  }),
);
